module.exports = __webpack_public_path__ + "static/media/cahliBanner.eb7b0062.png";